import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class UpdateArbetsorderRestriktionAnteckningCommand extends BasicCommand<UpdateArbetsorderRestriktionAnteckningCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId,
            typ: this.typ
        };
    }
    arbetsorderId: number;
    typ: string;
    anteckning: string;
    static readonly $type = "UpdateArbetsorderRestriktionAnteckningCommand";

    constructor(init: (instance: UpdateArbetsorderRestriktionAnteckningCommand) => void) {
        super("UpdateArbetsorderRestriktionAnteckningCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
